import Button from "@/components/ui/Button";
import TextField from "@/components/ui/Textfield";
import useAuthStore from "@/store/authStore";
import useGlobalStore from "@/store/globalStore";
import { useState, FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

export default function LoginPage() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const { login, user } = useAuthStore(
    useShallow((state) => ({ user: state.user, login: state.login })),
  );

  const setError = useGlobalStore((state) => state.setError);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Simple validation example
    if (!email) {
      setErrorMessage("Email is required.");
      return;
    }
    if (!password) {
      setErrorMessage("Password is required.");
      return;
    }
    setIsLoading(true);

    try {
      await login({ email, password });
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token || user) {
      // If token or user exists, redirect to the dashboard
      navigate("/dashboard");
    }
  }, [navigate, user]);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top Banner */}
      <div className="w-full bg-[#ea33c0] py-20 text-center">
        <h1 className="text-white text-3xl md:text-5xl font-bold">
          MediaBridge
        </h1>
      </div>

      {/* Login Section */}
      <div className="flex flex-col items-center justify-center flex-grow">
        <div className="max-w-md w-full">
          <h2 className="text-2xl font-bold text-center mb-6">User Login</h2>

          {/* Error Messages */}
          {errorMessage && (
            <div className="mb-4 w-2/3 mx-auto text-red-700 bg-red-100 border border-red-400 text-sm px-4 py-2 rounded">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="px-5 text-center">
              <TextField
                type="email"
                name="login"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full md:w-3/4"
              />
            </div>

            <div className="px-5 text-center">
              <TextField
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full md:w-3/4"
              />
            </div>

            <Button
              type="primary"
              className="mx-auto text-center px-10 text-white"
              isLoading={isLoading}
            >
              Sign in
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
